import { IconAttention, IconTimelineAlt, IconTrip } from '@flixbus/honeycomb-icons-react';

import { CREATE_BREAKDOWN_FLOW_TEXT } from 'pages/WorkAssignments/components/CreateBreakdownFlow/texts';

const LABELS = CREATE_BREAKDOWN_FLOW_TEXT.summary.rowLabels;

const formatStation = (stationDetails) => {
	if (!stationDetails?.code) return '';
	if (!stationDetails.name) return stationDetails.code;
	return `${stationDetails.code} (${stationDetails.name})`;
};

/**
 * Build the "Deadhead info" rows from an accepted breakdown.
 * Mirrors the flow-side deriver — `breakdown.deadhead` shape is identical
 * to the flow draft's `data.deadhead` (id, rideNumber, departure/arrival).
 *
 * @param {object} breakdown
 * @returns {import('common/BreakdownDetails').BreakdownDetailsRow[]}
 */
export const deriveDeadheadRowsFromBreakdown = (breakdown) => {
	const dh = breakdown?.deadhead;
	if (!dh) return [];

	const from = formatStation(dh.departure?.stationDetails);
	const to = formatStation(dh.arrival?.stationDetails);

	return [
		{
			label: LABELS.route,
			value: `${from} → ${to}`,
			icon: IconTrip,
		},
		{
			label: LABELS.schedule,
			value: dh.rideNumber ?? '',
			icon: IconTimelineAlt,
		},
		{
			label: LABELS.type,
			value: dh.type ?? '',
			icon: IconAttention,
		},
	];
};
